/* eslint-disable @typescript-eslint/no-magic-numbers */
import colors from 'Theme/lightTheme/colors';

export const colours = [
    {
        primary: colors.accents[6].hex,
        secondary: colors.accents[28].hex
    },
    {
        primary: colors.accents[2].hex,
        secondary: colors.accents[15].hex
    },
    {
        primary: colors.primary.hex,
        secondary: colors.primary.tints[3].hex
    },
    {
        primary: colors.accents[7].hex,
        secondary: colors.accents[29].hex
    },
    {
        primary: colors.accents[3].hex,
        secondary: colors.accents[12].hex
    },
    {
        primary: colors.accents[1].hex,
        secondary: colors.accents[13].hex
    },
    {
        primary: colors.accents[4].hex,
        secondary: colors.accents[11].hex
    }
];
